import { useEffect, useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import { AppNoInfo } from '@/layout/AppComponents';
import { axiosPath } from '../../../../../../routing/helpers/router';
import * as currentPageAction from '../../../../../../store/actions/currentPageAction';
import ResponsibleSelect from '../../../../../components/form/Selects/ResponsibleSelect';
import Translator from '../../../../../components/helpers/Translator';
import useIsMounted from '../../../../../components/hooks/useIsMounted';
import _ from 'lodash';

const ResponsibleTab = (props) => {
  const { plantObligationID } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const isMounted = useIsMounted();
  const dispatch = useDispatch();
  const responsibles = useSelector((s) => s.currentPage?.responsibleTabs?.[plantObligationID]);
  const [isLoading, setIsLoading] = useState(false);

  // > LOAD INFORMATION TAB
  useEffect(() => {
    if (!responsibles) {
      setIsLoading(true);
      (async () => {
        try {
          const response = await axios.post(
            axiosPath("api_r_user_module_legalCompliance_responsible_tab"),
            { moduleBridgeHex, plantHex, plantObligationID }
          );
          if (isMounted.current) {
            dispatch(currentPageAction.change('responsibleTabs', { [plantObligationID]: response.data }));
            setIsLoading(false);
          }
        } catch (err) {}
      })();
    }
  }, []);
  // < LOAD INFORMATION TAB

  const handleOnSubmit = async (values) => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        axiosPath("api_r_user_module_legalCompliance_responsible_edit"),
        { moduleBridgeHex, plantHex, plantObligationID, ...values }
      );
      if (isMounted.current) {
        dispatch(currentPageAction.change('responsibleTabs', { [plantObligationID]: response.data }, true));
        setIsLoading(false);
      }
    } catch (err) {}
  };

  if (isLoading) return <AppNoInfo minHeight={300} />;

  return (
    <Container className="p-3">
      <Formik
        initialValues={{
          responsibles: _.map(responsibles, 'value'),
        }}
        validateOnChange={false}
        validateOnBlur={false}
        enableReinitialize
        onSubmit={handleOnSubmit}
      >
        {({ setFieldValue, handleSubmit, values }) => (
          <>
            <ResponsibleSelect
              value={values.responsibles}
              onHandleChange={(opt) => setFieldValue('responsibles', opt)}
              apiCall="api_r_user_module_legalCompliance_responsible_getResponsibles"
              hasSearchBox
              isClearable
              onlyWithPlantAccess
            />
            <span
              className="btn btn-primary btn-xs float-right mb-2"
              onClick={handleSubmit}
            >
              <Translator file="general" name="general.update" />
            </span>
          </>
        )}
      </Formik>
      <div className="clearfix" />
      {responsibles ? (
        <table className="table">
          <tbody>
            {responsibles.map((r) => (
              <tr key={r.value}>
                <td>{r.label}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="alert alert-light">
          <Translator file="module-legalCompliance" name="no.responsibles.assigned" />
        </div>
      )}
    </Container>
  );
};
export default ResponsibleTab;

const Container = styled.div`
  height: 400px;
  tr>td{
    padding: 4px;
    font-size: 12px;
    &>div{
      height:20px;
      overflow-y:hidden;
      text-overflow:ellipsis;
      cursor: pointer;
    }
  }
`;
